import numeral from 'numeral';
import React from 'react';
import PropTypes from 'prop-types';
import { selectors as settingsSelectors } from 'state/settings';
import { useSelector } from 'react-redux';

const currencyFormat = {
  ES: '0,0.00 $',
  FR: '0,0.00 $',
  EN: '$0,0.00',
  NL: '$0,0.00',
};
const langToLocales = {
  ES: 'es-es',
  EN: 'en-gb',
  FR: 'fr',
  NL: 'nl-nl',
};

const LiteralCurrency = ({ value, strikethrough }) => {
  const country = useSelector(settingsSelectors.getCountry);
  numeral.locale(langToLocales[country]);
  const format = currencyFormat[country];
  const amount = numeral(Number(value)).format(format);
  return strikethrough ? <del>{amount}</del> : amount;
};

LiteralCurrency.propTypes = {
  value: PropTypes.number.isRequired,
  strikethrough: PropTypes.bool,
};

LiteralCurrency.defaultProps = {
  strikethrough: false,
};

export default LiteralCurrency;
